'use client';
import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';

export default function Header() {
  const router = useRouter();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className="fixed top-0 inset-x-0 z-50 transition-all duration-500"
      style={{
        background: scrolled ? 'rgba(13,13,13,0.92)' : 'transparent',
        backdropFilter: scrolled ? 'blur(16px)' : 'none',
        borderBottom: scrolled ? '1px solid rgba(63,63,70,0.6)' : 'none',
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between gap-3">
        {/* Logo text */}
        <div
          className="flex flex-col items-start cursor-pointer hover:opacity-80 transition-opacity min-w-0 flex-shrink"
          onClick={() => router?.push('/home')}
        >
          <span
            style={{
              fontSize: 'clamp(16px, 4vw, 22px)',
              fontWeight: '700',
              color: 'var(--white)',
              fontFamily: 'Manrope, sans-serif',
              letterSpacing: '0.12em',
              textTransform: 'uppercase',
              whiteSpace: 'nowrap',
            }}
          >
            ASA DETAILING
          </span>
          <span
            style={{
              fontSize: 'clamp(9px, 2vw, 10px)',
              color: 'var(--aluminum-dim)',
              fontFamily: 'DM Sans, sans-serif',
              letterSpacing: '0.04em',
              marginTop: '2px',
              whiteSpace: 'nowrap',
            }}
          >
            Partener RevMy.ro
          </span>
        </div>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-1">
          {[
            { label: 'Servicii', href: '#services' },
            { label: 'Comparație', href: '#compare' },
            { label: 'Rezervă Acum', href: 'https://revmy.ro/service-provider-profile/botosani/detailing/asa-detailing', isBook: true },
          ]?.map((item) =>
            item?.isBook ? (
              <a
                key={item?.label}
                href={item?.href}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary text-sm px-5 py-2.5 ml-2"
                style={{ fontSize: '14px', padding: '10px 22px' }}
              >
                Rezervă Acum
              </a>
            ) : (
              <a
                key={item?.label}
                href={item?.href}
                className="px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200"
                style={{ color: 'var(--aluminum-dim)', fontFamily: 'Manrope, sans-serif' }}
                onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--white)')}
                onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--aluminum-dim)')}
              >
                {item?.label}
              </a>
            )
          )}
        </nav>

        {/* Mobile CTA */}
        <a
          href="https://revmy.ro/service-provider-profile/botosani/detailing/asa-detailing"
          target="_blank"
          rel="noopener noreferrer"
          className="md:hidden btn-primary flex-shrink-0"
          style={{ fontSize: '12px', padding: '8px 14px', whiteSpace: 'nowrap' }}
        >
          Rezervă
        </a>
      </div>
    </header>
  );
}